<script setup lang="ts">

import { toRef } from "vue";
import PulsePill from "@/components/pulse/PulsePill.vue";
import PulseTimeAllocationDisplay from "@/components/pulse/PulseTimeAllocationDisplay.vue";
import { usePulseStats } from "@/composables/usePulseStats";
import type { CompanyPulseData } from "@/types/DataTypes";

interface Props {
  pulses: CompanyPulseData[];
}

const props = defineProps<Props>();

// Convert props to reactive reference for the composable
const pulsesRef = toRef(props, 'pulses');

// Use the centralized stats calculation logic
const { stats } = usePulseStats(pulsesRef);

</script>

<template>
  <div class="flex flex-row justify-between grow">
    <!-- Participation Stats -->
    <div class="flex gap-2 items-center">
      <span class="font-bold">Participation:</span>
      <PulsePill :day="{type: ''}">{{ stats.participationRate }}%</PulsePill>
      <PulsePill :day="{type: 'PULSE'}" v-if="stats.submitted" v-tooltip.top="'Submitted'">{{ stats.submitted }}</PulsePill>
      <PulsePill :day="{type: 'NO_INFO'}" v-if="stats.missing" v-tooltip.top="'Missing'">{{ stats.missing }}</PulsePill>
      <PulsePill :day="{type: 'OOO'}" v-if="stats.ooo" v-tooltip.top="'OOO'">{{ stats.ooo }}</PulsePill>
    </div>
    
    <!-- Daily Allocation Summary (includes unallocated) -->
    <div v-if="Object.keys(stats.companyAllocation).length > 0" class="w-2/4 pr-14 pl-4">
      <PulseTimeAllocationDisplay :time-allocation="stats.companyAllocation" :show-unallocated="true" :show-legend="true"/>
    </div>
  </div>
</template>
